import { Box } from '@atgfr8/atg-ui-tailwind';
import { AutoComplete } from '@components';
import BottomSheet from '@mobileComponents/BottomSheet';
import {
  customerDetailsStore,
  fetchCustomerOfficeGroupsCall,
  setCustomerDetailsStore,
  updateCustomerDetailsState,
} from '@mobileStore/customer';
import { IUserSearch } from '@typeDefinitions/customerTypes';
import {
  getMobileUserId,
  mobileIsAdmin,
  mobileIsSuperAdmin,
  mobileIsManager,
} from '@mobileUtils/roleUtils';
import { createSignal } from 'solid-js';

type RenderItemsProps = {
  item2: IUserSearch;
};

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
};

const AssignCustomer = (props: Props) => {
  const [localAccountOfficeId, setLocalAccountOfficeId] = createSignal<
    string | number
  >(customerDetailsStore.customer.accountManagerOfficeId ?? '');

  const handleGrouplistSelect = (item: IUserSearch, name: string) => {
    updateCustomerDetailsState({
      [`${name}ManagerName`]: item.name,
      [`${name}ManagerId`]: item.id,
    });
  };

  const fetchCustomerOfficeGroups = async (
    officeId: number,
    accountId?: number,
  ) => {
    const res = await fetchCustomerOfficeGroupsCall(officeId);

    if (res && res.isSuccess) {
      if (
        officeId ===
          (accountId ?? customerDetailsStore.customer.accountManagerOfficeId) ||
        officeId === customerDetailsStore.customer.salesManagerOfficeId
      ) {
        res.value = res.value.filter(
          (x) => x.name !== 'Managers' && x.name !== 'Admin',
        );
      }
      if (!mobileIsAdmin() && !mobileIsSuperAdmin()) {
        res.value = res.value.filter((x) => x.name !== 'The Office');
      }
      const assignOfficeGroupRes = res.value.map((item) => {
        return {
          ...item,
          label: `${item.name as string} (${item.office})`,
          value: item.id,
        };
      });
      setCustomerDetailsStore('assignOfficeGroup', assignOfficeGroupRes);
    }
  };

  const fetchAssignGroupData = async (officeId: number) => {
    await fetchCustomerOfficeGroups(officeId, Number(localAccountOfficeId()));
  };

  const RenderItem = (props: RenderItemsProps) => (
    <div class="overflow-auto max-h-[600px] flex flex-col">
      <span class="font-medium">{props.item2.name}</span>
      <span>
        Office: {props.item2.office} - {props.item2.accountingGroup}
      </span>
      <span>Email: {props.item2.userName}</span>
      <span>Phone: {props.item2.phone}</span>
    </div>
  );

  const DisableChangeManager = () => {
    return !(
      mobileIsAdmin() ||
      (customerDetailsStore.customer.status !== 'Dormant' &&
        (getMobileUserId() === customerDetailsStore.customer.accountManagerId ||
          getMobileUserId() === customerDetailsStore.customer.salesManagerId ||
          mobileIsManager()))
    );
  };

  return (
    <BottomSheet
      title="Assign Managers"
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <Box class="space-y-2.5">
        <AutoComplete
          endpoint="user/autocomplete/?term="
          version="v3"
          responseFieldName="name"
          onItemSelect={async (item) => {
            const { officeId = '' } = item as { officeId: number };
            setLocalAccountOfficeId(officeId);
            handleGrouplistSelect(item as IUserSearch, 'account');
            await fetchAssignGroupData(officeId as number);
          }}
          id="autocomplete-accountManagerName"
          label="Account Manager"
          value={customerDetailsStore.customer.accountManagerName ?? ''}
          renderItem={(item) => {
            const item2 = item as IUserSearch;
            return <RenderItem item2={item2} />;
          }}
          onClearValue={() => {
            updateCustomerDetailsState({
              accountManagerName: '',
              accountManagerId: null,
            });
          }}
          class="w-full"
          disabled={DisableChangeManager()}
        />
        <AutoComplete
          endpoint="user/autocomplete/?term="
          version="v3"
          responseFieldName="name"
          onItemSelect={(item) =>
            handleGrouplistSelect(item as IUserSearch, 'sales')
          }
          id="autocomplete-field-user"
          label="Sales Manager"
          value={customerDetailsStore.customer.salesManagerName ?? ''}
          renderItem={(item) => {
            const item2 = item as IUserSearch;
            return <RenderItem item2={item2} />;
          }}
          onClearValue={() => {
            updateCustomerDetailsState({
              salesManagerName: '',
              salesManagerId: null,
            });
          }}
          class="w-full"
          disabled={DisableChangeManager()}
        />
      </Box>
    </BottomSheet>
  );
};

export default AssignCustomer;
